import {api} from "@/store";

export default class ProgramAvailability{
    static async listPartners():Promise<any>{
        return await api.get('api/scheduling/partners');
    }

    static async getRedirectWindows(form:any):Promise<any>{
        return await api.post('api/scheduling/redirect-windows',form);
    }
}
